/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsLeftRightToLines: {
  name: 'arrows-left-right-to-lines';
  data: string;
} = {
  name: 'arrows-left-right-to-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 1.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5Zm14 0a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5ZM6.354 6.354a.5.5 0 1 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.207 8.5h5.586L9.646 9.646a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.708.708L10.793 7.5H5.207l1.147-1.146Z" fill="currentColor"/></svg>`,
};
